import type * as Immutable from 'immutable'
import { Stack } from '@mui/material'
import { useCallback } from 'react'
import ProductDesignLinkedStoreIcon from './ProductDesignLinkedStoreIcon'

interface Props {
  linkedStores: Immutable.OrderedSet<string>
}

export default function ProductDesignLinkedStores(props: Props) {
  const renderItem = useCallback((storeSlug: string) => {
    return <ProductDesignLinkedStoreIcon
      key={storeSlug}
      storeSlug={storeSlug}
    />
  }, [])

  return <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap">
    {props.linkedStores.valueSeq().map(renderItem)}
  </Stack>
}
